import { Modal } from 'antd';
import React from 'react';
import Spinner from './Spinner';
import TicIcon from '../Assets/Icons/TicIcon';
import CrossIcon from '../Assets/Icons/CrossIcon';

function DeletePostModal({
  handleDeleteOk,
  handleDeleteCancel,
  loader,
  deleteFun,
  modalText,
  subModalText,
  isDeleteModalOpen,
}) {
  return (
    <Modal
      footer={false}
      title={false}
      open={isDeleteModalOpen}
      onOk={handleDeleteOk}
      onCancel={handleDeleteCancel}
      className="max-w-[520px] w-full"
      width={'100%'}>
      <div className="py-[12px] px-[8px]">
        <h5 className="text-xl leading-[12px] font-semibold">{modalText}</h5>
        <p className="mt-3 text-gray-700">{subModalText}</p>
        <div className="flex items-center justify-between flex-wrap">
          <button
            disabled={loader}
            onClick={deleteFun}
            className={`relative flex items-center justify-center mt-6 rounded-xl py-4 ${
              loader ? 'bg-[#2a9134]' : 'bg-[#EEF2F0] '
            }   text-black hover:bg-[#2a9134]  hover:text-white border-[1px] leading-[8px] outline-none border-[#EEF2F0] px-9   font-semibold sm:w-[calc(50%-8px)] w-full `}>
            {loader ? <Spinner /> : null}
            <div className={loader ? `opacity-0 flex items-center justify-center` : 'flex items-center justify-center'}>
              <TicIcon className="mr-[12.12px]" stroke="currentColor" />
              Yes, Delete
            </div>
          </button>
          <button
            onClick={handleDeleteCancel}
            className="flex items-center justify-center mt-6 rounded-xl py-4 bg-[#EEF2F0]  text-black hover:bg-[#2a9134]  hover:text-white border-[1px] leading-[8px] outline-none border-[#EEF2F0] px-9   font-semibold sm:w-[calc(50%-8px)] w-full">
            <CrossIcon className="mr-[11.89px]" stroke="currentColor" />
            No
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default DeletePostModal;
